/**
 * CoLab Lightbox & Gallery Modules
 *
 * Два компоненти:
 * 1. Lightbox - простий лайтбокс для одного зображення
 * 2. Gallery - міні-галерея з головним фото, thumbnails та fullscreen
 */

// ============================================
// Shared Fullscreen Modal (використовується обома компонентами)
// ============================================

const FullscreenModal = {
    element: null,
    image: null,
    closeBtn: null,
    prevBtn: null,
    nextBtn: null,
    counter: null,
    overlay: null,

    isOpen: false,
    images: [],
    currentIndex: 0,
    onNavigate: null, // callback для синхронізації з галереєю

    /**
     * Створити або отримати існуючий modal
     */
    create: function() {
        if (this.element) return;

        // Перевіряємо чи вже існує
        var existing = document.querySelector('.lightbox-modal');
        if (existing) {
            this.element = existing;
            this.cacheElements();
            return;
        }

        var html = '\
            <div class="lightbox-modal">\
                <div class="lightbox-modal__overlay"></div>\
                <div class="lightbox-modal__content">\
                    <img class="lightbox-modal__img" src="" alt="">\
                </div>\
                <button class="lightbox-modal__close" aria-label="Закрити">\
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">\
                        <path d="M18 6L6 18M6 6l12 12"/>\
                    </svg>\
                </button>\
                <button class="lightbox-modal__prev" aria-label="Попереднє">\
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">\
                        <path d="M15 18l-6-6 6-6"/>\
                    </svg>\
                </button>\
                <button class="lightbox-modal__next" aria-label="Наступне">\
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">\
                        <path d="M9 18l6-6-6-6"/>\
                    </svg>\
                </button>\
                <div class="lightbox-modal__counter">\
                    <span class="lightbox-modal__current">1</span>\
                    <span class="lightbox-modal__separator">/</span>\
                    <span class="lightbox-modal__total">1</span>\
                </div>\
            </div>\
        ';

        document.body.insertAdjacentHTML('beforeend', html);
        this.element = document.querySelector('.lightbox-modal');
        this.cacheElements();
        this.bindEvents();
    },

    /**
     * Кешуємо DOM елементи
     */
    cacheElements: function() {
        this.image = this.element.querySelector('.lightbox-modal__img');
        this.closeBtn = this.element.querySelector('.lightbox-modal__close');
        this.prevBtn = this.element.querySelector('.lightbox-modal__prev');
        this.nextBtn = this.element.querySelector('.lightbox-modal__next');
        this.counter = this.element.querySelector('.lightbox-modal__counter');
        this.overlay = this.element.querySelector('.lightbox-modal__overlay');
    },

    /**
     * Прив'язуємо події
     */
    bindEvents: function() {
        var self = this;

        this.closeBtn.addEventListener('click', function() {
            self.close();
        });

        this.overlay.addEventListener('click', function() {
            self.close();
        });

        this.prevBtn.addEventListener('click', function(e) {
            e.stopPropagation();
            self.prev();
        });

        this.nextBtn.addEventListener('click', function(e) {
            e.stopPropagation();
            self.next();
        });

        // Keyboard
        document.addEventListener('keydown', function(e) {
            if (!self.isOpen) return;

            if (e.key === 'Escape') {
                self.close();
            } else if (e.key === 'ArrowLeft') {
                self.prev();
            } else if (e.key === 'ArrowRight') {
                self.next();
            }
        });

        // Touch swipe
        this.bindSwipe();
    },

    /**
     * Touch swipe підтримка
     */
    bindSwipe: function() {
        var self = this;
        var startX = 0;
        var startY = 0;

        this.element.addEventListener('touchstart', function(e) {
            startX = e.changedTouches[0].pageX;
            startY = e.changedTouches[0].pageY;
        }, { passive: true });

        this.element.addEventListener('touchend', function(e) {
            var deltaX = e.changedTouches[0].pageX - startX;
            var deltaY = e.changedTouches[0].pageY - startY;

            if (Math.abs(deltaX) > 50 && Math.abs(deltaX) > Math.abs(deltaY)) {
                if (deltaX > 0) {
                    self.prev();
                } else {
                    self.next();
                }
            }
        }, { passive: true });
    },

    /**
     * Відкрити modal
     * @param {Array} images - масив об'єктів {src, alt}
     * @param {Number} index - початковий індекс
     * @param {Function} onNavigate - callback при навігації (для синхронізації)
     */
    open: function(images, index, onNavigate) {
        this.create();

        this.images = images;
        this.currentIndex = index || 0;
        this.onNavigate = onNavigate || null;
        this.isOpen = true;

        this.updateImage();
        this.updateUI();

        this.element.classList.add('is-active');
        document.body.style.overflow = 'hidden';
    },

    /**
     * Закрити modal
     */
    close: function() {
        this.isOpen = false;
        this.element.classList.remove('is-active');
        document.body.style.overflow = '';
        this.onNavigate = null;
    },

    /**
     * Попереднє зображення
     */
    prev: function() {
        if (this.currentIndex > 0) {
            this.currentIndex--;
            this.updateImage();
            this.updateUI();

            if (this.onNavigate) {
                this.onNavigate(this.currentIndex);
            }
        }
    },

    /**
     * Наступне зображення
     */
    next: function() {
        if (this.currentIndex < this.images.length - 1) {
            this.currentIndex++;
            this.updateImage();
            this.updateUI();

            if (this.onNavigate) {
                this.onNavigate(this.currentIndex);
            }
        }
    },

    /**
     * Перейти до конкретного зображення
     */
    goTo: function(index) {
        if (index >= 0 && index < this.images.length) {
            this.currentIndex = index;
            this.updateImage();
            this.updateUI();
        }
    },

    /**
     * Оновити зображення з анімацією
     */
    updateImage: function() {
        var self = this;
        var img = this.images[this.currentIndex];

        this.image.style.opacity = '0';

        setTimeout(function() {
            self.image.src = img.src;
            self.image.alt = img.alt || '';
            self.image.style.opacity = '1';
        }, 150);
    },

    /**
     * Оновити UI (counter, кнопки)
     */
    updateUI: function() {
        var isSingle = this.images.length === 1;

        // Counter
        if (isSingle) {
            this.counter.style.display = 'none';
            this.prevBtn.style.display = 'none';
            this.nextBtn.style.display = 'none';
        } else {
            this.counter.style.display = '';
            this.prevBtn.style.display = '';
            this.nextBtn.style.display = '';

            this.element.querySelector('.lightbox-modal__current').textContent = this.currentIndex + 1;
            this.element.querySelector('.lightbox-modal__total').textContent = this.images.length;

            // Disabled states
            this.prevBtn.classList.toggle('is-disabled', this.currentIndex === 0);
            this.nextBtn.classList.toggle('is-disabled', this.currentIndex === this.images.length - 1);
        }
    }
};


// ============================================
// Lightbox - Простий лайтбокс для одного зображення
// ============================================

export const Lightbox = {

    config: {
        selector: '[data-lightbox]',
        groupAttribute: 'data-lightbox-group'
    },

    groups: {},

    /**
     * Ініціалізація
     */
    init: function(options) {
        var self = this;

        if (options) {
            this.config = Object.assign({}, this.config, options);
        }

        var elements = document.querySelectorAll(this.config.selector);

        if (elements.length === 0) return;

        // Групуємо елементи
        this.groups = {};

        elements.forEach(function(el) {
            var group = el.getAttribute(self.config.groupAttribute) || 'default';

            if (!self.groups[group]) {
                self.groups[group] = [];
            }

            self.groups[group].push({
                element: el,
                src: el.getAttribute('data-lightbox') || el.href || el.src,
                alt: el.getAttribute('data-lightbox-alt') || el.querySelector('img')?.alt || ''
            });
        });

        // Прив'язуємо кліки
        elements.forEach(function(el) {
            el.addEventListener('click', function(e) {
                e.preventDefault();
                self.handleClick(el);
            });

            // Cursor style
            el.style.cursor = 'zoom-in';
        });

        console.log('[CoLab.Lightbox] Initialized with', elements.length, 'elements');
    },

    /**
     * Обробка кліку
     */
    handleClick: function(element) {
        var group = element.getAttribute(this.config.groupAttribute) || 'default';
        var items = this.groups[group];

        // Знаходимо індекс поточного елемента
        var index = 0;
        for (var i = 0; i < items.length; i++) {
            if (items[i].element === element) {
                index = i;
                break;
            }
        }

        // Формуємо масив зображень
        var images = items.map(function(item) {
            return { src: item.src, alt: item.alt };
        });

        FullscreenModal.open(images, index);
    },

    /**
     * Програмне відкриття
     */
    open: function(src, alt) {
        FullscreenModal.open([{ src: src, alt: alt || '' }], 0);
    }
};


// ============================================
// Gallery - Галерея з thumbnails
// ============================================

export const Gallery = {
    instances: [],

    config: {
        containerSelector: '.gallery',
        mainImageSelector: '.gallery__main-img',
        mainWrapperSelector: '.gallery__main',
        thumbSelector: '.gallery__thumb',
        animationDuration: 150
    },

    /**
     * Ініціалізація всіх галерей
     */
    init: function(selector, options) {
        var self = this;
        var config = Object.assign({}, this.config, options || {});

        var containers = document.querySelectorAll(selector || config.containerSelector);

        if (containers.length === 0) return;

        containers.forEach(function(container) {
            self.initInstance(container, config);
        });

        console.log('[CoLab.Gallery] Initialized', containers.length, 'galleries');
    },

    /**
     * Ініціалізація окремої галереї
     */
    initInstance: function(container, config) {
        var self = this;

        var instance = {
            container: container,
            mainImage: container.querySelector(config.mainImageSelector),
            mainWrapper: container.querySelector(config.mainWrapperSelector),
            thumbs: container.querySelectorAll(config.thumbSelector),
            images: [],
            currentIndex: 0
        };

        if (!instance.mainImage || !instance.thumbs.length) return;

        // Збираємо зображення
        instance.thumbs.forEach(function(thumb) {
            instance.images.push({
                src: thumb.dataset.full || thumb.querySelector('img')?.src || thumb.src,
                alt: thumb.querySelector('img')?.alt || thumb.alt || ''
            });
        });

        // Thumbnail clicks
        instance.thumbs.forEach(function(thumb, index) {
            thumb.addEventListener('click', function() {
                self.setActiveThumb(instance, index, config);
            });
        });

        // Main image click → fullscreen
        instance.mainWrapper.addEventListener('click', function() {
            self.openFullscreen(instance);
        });

        // Initial state
        this.setActiveThumb(instance, 0, config);

        this.instances.push(instance);
    },

    /**
     * Встановити активний thumbnail
     */
    setActiveThumb: function(instance, index, config) {
        if (index < 0 || index >= instance.images.length) return;

        instance.currentIndex = index;

        // Update thumbs
        instance.thumbs.forEach(function(thumb, i) {
            thumb.classList.toggle('is-active', i === index);
        });

        // Update main image with fade
        instance.mainImage.style.opacity = '0';

        setTimeout(function() {
            instance.mainImage.src = instance.images[index].src;
            instance.mainImage.alt = instance.images[index].alt;
            instance.mainImage.style.opacity = '1';
        }, config.animationDuration);
    },

    /**
     * Відкрити fullscreen
     */
    openFullscreen: function(instance) {
        var self = this;

        FullscreenModal.open(
            instance.images,
            instance.currentIndex,
            function(index) {
                // Синхронізація з галереєю при навігації в fullscreen
                self.setActiveThumb(instance, index, self.config);
            }
        );
    }
};


// ============================================
// Auto-init
// ============================================

document.addEventListener('DOMContentLoaded', function() {
    // Ініціалізуємо Lightbox для всіх елементів з data-lightbox
    if (document.querySelector('[data-lightbox]')) {
        Lightbox.init();
    }

    // Ініціалізуємо Gallery для всіх .gallery
    if (document.querySelector('.gallery')) {
        Gallery.init();
    }
});
